import {
  ChatDotsIcon,
  CheckCircleIcon,
  PaperPlaneIcon,
} from '@nimbus-ds/icons';
import { InitialScreen } from '@nimbus-ds/patterns';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import EmptyState from './assets/whatsapp-empty-state.png';

export function WhatsAppInitialScreen() {
  const t = useTranslationConfigurations(
    'notifications.whatsapp.initialScreen',
  );

  const bulletData = [
    {
      icon: <ChatDotsIcon />,
      description: t('bullets.openRate'),
    },
    {
      icon: <PaperPlaneIcon />,
      description: t('bullets.delivery'),
    },
    {
      icon: <CheckCircleIcon />,
      description: t('bullets.templates'),
    },
  ];

  return (
    <div className="stratus--whatsapp-initial-screen">
      <InitialScreen>
        <InitialScreen.Hero
          subtitle={t('subtitle')}
          title={t('title')}
          bullets={bulletData.map(({ icon, description }) => (
            <InitialScreen.Bullet
              key={description}
              icon={icon}
              text={description}
            />
          ))}
          image={<img src={EmptyState} alt="" width="100%" />}
        />
      </InitialScreen>
    </div>
  );
}
